import { message } from 'antd';

// Recharge les sections liées du document ouvert (store.reloadLinkedSections). Si des sections n'ont pas pu être
// lues dans la bibliothèque, rien n'est modifié et l'utilisateur choisit : recharger les autres, ou ne rien faire.
// keepAnswers : les questions de ces sections gardent leur réponse.
export const runReloadLinkedSections = async ({ reloadLinkedSections, modalApi, keepAnswers = true }) => {
  const result = (await reloadLinkedSections({ keepAnswers })) ?? {};
  if (result.error) {
    message.error(result.error);
    return;
  }
  if (!result.unreadable) return;

  const reloadOthers = await new Promise((resolve) => {
    modalApi.confirm({
      title: 'Sections illisibles',
      content: `${result.unreadable} section(s) liée(s) n'ont pas pu être lues dans la bibliothèque. Recharger les autres sections ? Les sections illisibles restent telles quelles.`,
      okText: 'Recharger les autres',
      cancelText: 'Ne rien faire',
      centered: true,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
  if (!reloadOthers) return;
  const retry = (await reloadLinkedSections({ skipUnreadable: true, keepAnswers })) ?? {};
  if (retry.error) message.error(retry.error);
};
